import React, { useState, useEffect } from 'react'
import { Http } from '../../../helpers/axois';
import { Table } from 'antd';
import moment from 'moment';
import style from './env.module.sass'
import { logger } from '../../../constant/winston';

interface Props {
    env: any
}


const Apps: React.FC<Props> = (props) => {
    const [count, setcount] = useState(0);
    const [list, setlist] = useState<any>();

    const columns = [
        {
            title: "App Name",
            dataIndex: "appName",
            key: "app_name"

        },
        {
            title: "Version",
            dataIndex: "versionTag",
            key: "version_tag"
        },
        {
            title: "Deployed Time",
            dataIndex: "createdAt",
            key: "created_at",
            render: (text: any) => <span>{moment(text).fromNow()}</span>,
        },
        {
            title: "Deployed By ",
            dataIndex: "userName",
            key: "user_name"

        }
    ]
    useEffect(() => {
        if (count === 0) {
            Http.get(`environments/apps/${props.env.id}`).subscribe((res) => {
                setlist(res);
            },(err) => {
                logger.error(err);
            });
            setcount(1);
        }
    }, [count, props])


    return (
        <React.Fragment>
            <div className={style.envTableContainer}>
                {list && <Table
                    columns={columns}
                    onRow={(record: any, rowIndex: any) => {
                        return {
                            'data-test-id': 'environment_table_row_' + record.key,
                            onClick: (event: any) => {
                                // let target: any = event.target;
                            }
                        };
                    }}
                    className='override-table-container'
                    dataSource={list.map((res: any, key: number) => {
                        return { ...res, key: key };
                    })}
                />}
            </div>
        </React.Fragment>
    )
}


export default Apps;
